<h2 class="results-label-h2">Compare Results</h2>
<div class="compare-results-wrapper">
<div class="compare-item" *ngFor="let device of compareResultsList">

    <app-compare-results-card [deviceInfo]="device" (onRemoveItem)="onRemoveItem($event)"></app-compare-results-card>
</div>
</div>
